import { render } from "./ExpanderResourceSetVideo.vue?vue&type=template&id=f53f6990&scoped=true"
import script from "./ExpanderResourceSetVideo.vue?vue&type=script&lang=js"
export * from "./ExpanderResourceSetVideo.vue?vue&type=script&lang=js"

import "./ExpanderResourceSetVideo.vue?vue&type=style&index=0&id=f53f6990&scoped=true&lang=scss"

import exportComponent from "/Users/ondrej/dev/www/_showheroes/2023/norway/honda-w37/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f53f6990"]])

export default __exports__